import request from '@/utils/request'

const post = (url, data) => request({ method: 'POST', url, params: data })
const get = (url, params) => request({ method: 'GET', url, params })

export const applyInvoice = (data) => post('/taxapi/buffalo/applyInvoice', data)
export const checkApplyInfo = (params) => get('/taxapi/buffalo/checkApplayInfo', params)
export const createPayOrderWithExpress = (data) =>
  post('/taxapi/buffalo/createPayOrderWithExpress', data)
export const getBanklist = () => get('/taxapi/buffalo/getBanklist')
export const getInfo = (params) => get('/taxapi/buffalo/getInfo', params)
export const saveFile = (data) => post('/taxapi/buffalo/saveFile', data)
export const saveTransferred = (data) => post('/taxapi/buffalo/saveTransferred', data)
export const getPayMethod = () => get('/taxapi/buffalo/getPaymethod')
export const checkTel = (data) => post('/taxapi/buffalo/checkVatPamentTel', data)

export const uploadUrl = `${import.meta.env.VITE_BASE_URL}/taxapi/buffalo/uplopadFile`
